import { createSlice } from "@reduxjs/toolkit";

const initialUserAssignmentState = {
  listLoading: false,
  actionsLoading: false,
  userGroups: [],
  userIds: [],
  filters: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const userAssignmentSlice = createSlice({
  name: "userAssignment",
  initialState: initialUserAssignmentState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getList
    listFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.userGroups = action.payload.entities;
      state.authorities =  action.payload.authorities;
    },
    // getUserGroups
    userGroupsFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.userGroups = action.payload.entities;
    },
    // getUsers
    usersFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities =  authorities;
    },
    // getFilters
    filtersFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.filters = action.payload.entities;
    },
    //getUserIds
    userIdsFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.userIds = action.payload.ids;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanList
    listCleaned: (state) => {
      state.authorities = undefined;
      state.userGroups = [];
    },
    // cleanUserIds
    userIdsCleaned: (state) => {
      state.userIds = [];
    },
    // cleanUsers
    usersCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
    }
  }
});